import React from 'react';
import { Grid, Hidden } from '@mui/material';
import Logo from 'components/Logo';
import { styled } from '@mui/material/styles';
import { spacing } from 'styles/Common';

const StyledGrid = styled(Grid)((
    {
        theme
    }
    ) => {
        return {
            marginTop: spacing[7],
            marginBottom: spacing[9],
            [theme.breakpoints.down('lg')]: {
                marginTop: '22px',
                marginBottom: '22px'
            }
        };
    });

const PublicHeader = () => {

    return (
        <StyledGrid container alignItems="center" justifyContent="center">
            <Grid item xs={12}>
                <Grid container alignItems="center" justifyContent="center" direction="column">
                    <Grid item>
                        <Hidden lgUp>
                            <Logo width="91" height="40" />
                        </Hidden>
                        <Hidden lgDown>
                            <Logo width="186" height="58" />
                        </Hidden>
                    </Grid>
                </Grid>
            </Grid>
        </StyledGrid>
    );
};

export default PublicHeader;